export class PlayMatUtil{
    static fixBodyClass(campaignNo:number,scenarioNo:number){
        const domTokenList = document.body.classList;
        let campaignClasses: string[] = [];
        if (campaignNo) {
            const incamp = "in-campaign";
            const incampx = incamp + "-" + campaignNo;
            const incampxy = incampx + "-" + scenarioNo;
            campaignClasses = [incamp, incampx, incampxy];
            for (let j = 0; j < campaignClasses.length; j++) {
                if (!domTokenList.contains(campaignClasses[j])) {
                    domTokenList.add(campaignClasses[j]);
                }
            }
        }
        var classesToRemove: string[] = [];
        for (let i = 0; i < domTokenList.length; i++) {
            const currentClass = domTokenList[i]
            if (!currentClass.startsWith("in-campaign"))
                continue;
            let remove = true;
            for (let j = 0; j < campaignClasses.length; j++) {
                if (currentClass === campaignClasses[j]) {
                    remove = false;
                    break;
                };
            }
            if (remove) {
                classesToRemove.push(currentClass);
            }
        }
        for (let i = 0; i < classesToRemove.length; i++) {
            domTokenList.remove(classesToRemove[i]);
        }
    }
}